export default "__VITE_ASSET__f0762fe0__"